import {
    ComponentHelper,
    MappedStammdatenEmpfangsbevollmaechtigter,
    TaskDataService,
    WizardPageBaseComponent
} from '@utils-lib';
import {Component, OnInit} from '@angular/core';
import {AppNameEnum, EmpfangsbevollmaechtigterAngaben, PersonenTypEnumLabels, SteuerlicheBeratungAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';
import {SteuerlicheBeratungAngabenComponent} from '../steuerliche-beratung-angaben/steuerliche-beratung-angaben.component';

@Component({
    selector: 'common-ui-empfangsbevollmaechtigter-angaben',
    templateUrl: './empfangsbevollmaechtigter-angaben.component.html'
})
export class EmpfangsbevollmaechtigterAngabenComponent extends WizardPageBaseComponent<EmpfangsbevollmaechtigterAngaben> implements OnInit {

    static nutzdatenPath = 'empfangsbevollmaechtigterAngaben';
    static route = 'empfangsbevollmaechtigter-angaben';

    public personenTypEnum = PersonenTypEnumLabels;
    public filteredStammdaten;
    public emptySteuerberater = true;
    public showMerkerParagraph183 = false;

    constructor(protected readonly activatedRoute: ActivatedRoute, private readonly taskDataService: TaskDataService) {
        super(activatedRoute);
        const formular = ComponentHelper.getAppEnum(activatedRoute.snapshot);
        if (formular === AppNameEnum.FragebogenPersG) {
            this.showMerkerParagraph183 = true;
        }
    }

    public ngOnInit(): void {
        super.ngOnInit();

        const doesNotHaveVollmacht = (this.stammdaten?.empfangsbevollmaechtigter?.steuerberaterVollmacht === undefined ||
            this.stammdaten?.empfangsbevollmaechtigter?.steuerberaterVollmacht === false);

        if (!(doesNotHaveVollmacht &&
            !this.stammdaten?.empfangsbevollmaechtigter?.personenTyp &&
            !this.stammdaten?.empfangsbevollmaechtigter?.natuerlichePerson &&
            !this.stammdaten?.empfangsbevollmaechtigter?.juristischePerson)) {
            this.filteredStammdaten = this.stammdaten?.empfangsbevollmaechtigter;
        }

        const berater = this.taskDataService.getNutzdaten(SteuerlicheBeratungAngabenComponent.nutzdatenPath) as SteuerlicheBeratungAngaben;
        if ((berater.personenTyp === PersonenTypEnumLabels.NNatPers && berater.juristischePerson?.firmenname)
            || (berater.personenTyp === PersonenTypEnumLabels.NatPers && berater.natuerlichePerson?.nachname)) {
            this.emptySteuerberater = false;
        }
    }

    public onSteuerberaterVollmachtChanged(): void {
        if (this.data.steuerberaterVollmacht) {
            this.data.personenTyp = null;
            this.data.natuerlichePerson = null;
            this.data.juristischePerson = null;
            this.data.inlandsadresse = null;
            this.data.auslandsadresse = null;
            this.data.kommunikationsmittel = null;
        }
    }

    public personTypeChanged($event: unknown): void {
        if ($event === PersonenTypEnumLabels.NatPers) {
            this.data.juristischePerson = null;
        } else if ($event === PersonenTypEnumLabels.NNatPers) {
            this.data.natuerlichePerson = null;
        } else {
            this.data.natuerlichePerson = null;
            this.data.juristischePerson = null;
            this.data.inlandsadresse = null;
            this.data.auslandsadresse = null;
            this.data.kommunikationsmittel = null;
        }
    }

    public onEmpfangsbevollmaechtigterPicked(empfangsbevollmaechtigter: MappedStammdatenEmpfangsbevollmaechtigter): void {
        this.data.personenTyp = empfangsbevollmaechtigter.personenTyp;
        if (empfangsbevollmaechtigter.steuerberaterVollmacht) {
            this.data.steuerberaterVollmacht = empfangsbevollmaechtigter.steuerberaterVollmacht;
        }
        if (empfangsbevollmaechtigter.natuerlichePerson) {
            this.data.steuerberaterVollmacht = false;
            this.data.natuerlichePerson = empfangsbevollmaechtigter.natuerlichePerson;
        }
        if (empfangsbevollmaechtigter.juristischePerson) {
            this.data.steuerberaterVollmacht = false;
            this.data.juristischePerson = empfangsbevollmaechtigter.juristischePerson;
        }
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
        return new Map<string, unknown | Array<unknown>>([
            ['steuerberaterVollmacht', this.stammdaten?.empfangsbevollmaechtigter?.steuerberaterVollmacht],
            ['personenTyp', !this.stammdaten?.empfangsbevollmaechtigter?.steuerberaterVollmacht ?
                this.stammdaten?.empfangsbevollmaechtigter?.personenTyp : undefined],
            ['natuerlichePerson', !this.stammdaten?.empfangsbevollmaechtigter?.steuerberaterVollmacht ?
                this.stammdaten?.empfangsbevollmaechtigter?.natuerlichePerson : undefined],
            ['juristischePerson', !this.stammdaten?.empfangsbevollmaechtigter?.steuerberaterVollmacht ?
                this.stammdaten?.empfangsbevollmaechtigter?.juristischePerson : undefined],
            ['inlandsadresse', this.stammdaten?.empfangsbevollmaechtigter?.inlandsadressen],
            ['auslandsadresse', this.stammdaten?.empfangsbevollmaechtigter?.auslandsadressen],
            ['postfachadresse', this.stammdaten?.empfangsbevollmaechtigter?.postfachadressen],
            ['kommunikationsmittel.telefonnummern[0]', this.stammdaten?.empfangsbevollmaechtigter?.kommunikation?.telefonnummern],
        ]);
    }
}
